export default {"src":"/_next/static/media/Chevron-up.21d52467.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};